var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.4 62.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a37b50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.96,
    cy: 25.79,
    rx: 19.39,
    ry: 62.59,
    transform: "translate(27.28 83.26) rotate(-81.49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 277.07,
    cy: 25.57,
    rx: 62.59,
    ry: 19.39,
    transform: "translate(3.93 78.63) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.71,5A47.18,47.18,0,0,1,138.3,16.55a41.9,41.9,0,0,1,6.92,15.2,30.24,30.24,0,0,1-1,16.83A31.48,31.48,0,0,1,134.71,62a63,63,0,0,0,3.92-7,35.07,35.07,0,0,0,2.61-7.31,31,31,0,0,0,.89-7.54,33.18,33.18,0,0,0-.82-7.54,53,53,0,0,0-5.66-14.37c-1.28-2.29-2.65-4.55-4.17-6.74S128.39,7.12,126.71,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.36,4.62c-1.31,2.38-2.53,4.77-3.63,7.2a78.5,78.5,0,0,0-3,7.34,53.37,53.37,0,0,0-3.21,15.1,33,33,0,0,0,.44,7.57,30.75,30.75,0,0,0,2.13,7.29,35.34,35.34,0,0,0,3.78,6.78,66.28,66.28,0,0,0,5,6.26,31.45,31.45,0,0,1-11.63-11.64,30.32,30.32,0,0,1-3.74-16.45,42.11,42.11,0,0,1,4.31-16.13A47,47,0,0,1,214.36,4.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset 5.2504b6fc.svg";
export { ForwardRef as ReactComponent };